@if (displayMode === 'menuItem') {
  <button
    mat-menu-item
    [matMenuTriggerFor]="templateMenu"
    (menuOpened)="menuOpened.emit(); focusSearchInput()"
  >
    <mat-icon>{{ iconName }}</mat-icon>
    <span>Template</span>
  </button>

  <mat-menu #templateMenu="matMenu">
    <div class="h-[400px] overflow-y-auto p-0">
      <div
        class="sticky top-0 z-10 w-full border-b border-gray-200 bg-white px-4 py-2"
        (click)="$event.stopPropagation()"
        (keydown)="onMenuKeydown($event)"
      >
        <mat-form-field
          class="w-full"
          subscriptSizing="dynamic"
          floatLabel="never"
        >
          <input
            #searchInput
            matInput
            placeholder="Search Templates..."
            [formControl]="templateFilterCtrl"
          />
        </mat-form-field>
      </div>
      <div class="menu-items-wrapper">
        @if (filteredOptions$ | async; as options) {
          @for (option of options; track option.group) {
            <div class="px-2 py-1">
              <div class="px-2 text-xs font-semibold text-gray-500">
                {{ option.group | splitCamel | titlecase }}
              </div>
              @for (template of option.items; track $index + template.label) {
                <button
                  mat-menu-item
                  (click)="templateCtrl.setValue(template.value)"
                >
                  {{ template.label }}
                </button>
              }
            </div>
          } @empty {
            <div class="px-4 py-2 text-sm text-gray-500">
              No templates found for "{{ templateFilterCtrl.value }}"
            </div>
          }
        }
      </div>
    </div>
  </mat-menu>
}

@if (displayMode === 'inline') {
  <mat-form-field
    class="compact flex-1"
    subscriptSizing="dynamic"
    floatLabel="never"
  >
    <mat-select panelWidth [formControl]="templateCtrl">
      @if (filteredOptions$ | async; as options) {
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="No templates found"
            placeholderLabel="Search Templates..."
            [formControl]="templateFilterCtrl"
          />
        </mat-option>

        @for (option of options; track option.group) {
          <mat-optgroup [label]="option.group | splitCamel | titlecase">
            @for (template of option.items; track $index + template.label) {
              <mat-option [value]="template.value">
                {{ template.label }}
              </mat-option>
            }
          </mat-optgroup>
        }
      }
    </mat-select>

    <mat-label>
      <pt-loader-placeholder
        placeholder="Apply Template"
        loadingPlaceholder="Loading Templates..."
        [loading]="(loading$ | async) || (resolving$ | async)"
      />
    </mat-label>
  </mat-form-field>
}
